import { Component, OnInit, OnDestroy, Input, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { Client, ClientPurchase } from '@mira-avant/mtlibs';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { RouterModule } from '@angular/router';
import { ZorroModule } from '../../../../modules/zorro.module';
import { PurchaseService } from '../../../../services/purchase';

@Component({
	selector: 'app-purchases-table',
	standalone: true,
	imports: [
		CommonModule,
		NzTableModule,
		NzButtonModule,
		NzTypographyModule,
		RouterModule,
		ZorroModule,
	],
	templateUrl: './purchases-table.html',
	styleUrl: './purchases-table.scss',
})
export class PurchasesTable implements OnInit, OnDestroy {
	@Input('selectedClient') public selectedClient: Client | undefined;
	@Input('mode') public mode: 'select' | 'edit' = 'edit';
	public purchases: ClientPurchase[] = [];
	private subscriptions: Subscription = new Subscription();

	constructor(public purchaseService: PurchaseService) {}

	ngOnInit(): void {
		// Subscribe to purchases
		this.subscriptions.add(
			this.purchaseService.purchases$.subscribe(purchases => {
				this.purchases = purchases;
			})
		);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!this.selectedClient) {
			return;
		}

		// Fetch purchases (assuming a client_uuid is provided or handled elsewhere)
		this.purchaseService.getPurchasesByClient$(this.selectedClient.uuid).catch(error => {
			console.error('Error fetching purchases:', error);
			this.purchases = [];
		});
	}

	public selectPurchase(purchase: ClientPurchase | undefined): void {
		this.purchaseService.selectPurchase(purchase);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
